import React from 'react';

/**
 * AccordionContext
 * {
 *  toggle: PropTypes.func.isRequired,
 *  openId: PropTypes.string,
 * }
 */
export var AccordionContext = /*#__PURE__*/React.createContext({});